import { AnalyticsEvent } from 'analytics';
import { ChromeAppMessageType } from 'Environment/ChromeApp/types';
import { ChromeAppEventType } from 'Workspace/TelemetryEvents/TelemetryEventTypes';

type ChromeAppEventMetadata = {
	messageType: ChromeAppMessageType;
	correlationId: string;
	errorMessage?: string;
};

const code = 'WSUI_CHROME_APP';

const preparePayload = (
	type: string,
	metadata: ChromeAppEventMetadata
): AnalyticsEvent => ({
	type,
	code,
	...metadata,
});

export const ChromeAppEventPayload = {
	postMessageSent: (data: ChromeAppEventMetadata): AnalyticsEvent =>
		preparePayload(ChromeAppEventType.PostMessageSent, data),
	postMessageResponse: (data: ChromeAppEventMetadata): AnalyticsEvent =>
		preparePayload(ChromeAppEventType.PostMessageResponse, data),
	postMessageError: (data: ChromeAppEventMetadata): AnalyticsEvent =>
		preparePayload(ChromeAppEventType.PostMessageError, data),
};
